document.addEventListener('DOMContentLoaded', function() {
    function initSlider(slider) {
        if (slider.swiperInst) return;

        const nextButton = slider.querySelector('[data-slider-next]');
        const prevButton = slider.querySelector('[data-slider-prev]');
        const scrollSlider = slider.querySelector('.swiper');
        if (!scrollSlider) return;

        slider.swiperInst = new Swiper(scrollSlider, {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 400,
            breakpoints: {
                480: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 24
                },
                1024: {
                    slidesPerView: 4
                }
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton
            }
        });
    }

    const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initSlider(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null,
        rootMargin: '0px 0px 100px 0px',
        threshold: 0.1
    });

    document.querySelectorAll('[data-recomendations-carousel]').forEach(slider => {
        io.observe(slider);
    });

    document.addEventListener('recommendations:loaded', function(e) {
        e.detail.section.querySelectorAll('[data-recomendations-carousel]').forEach(slider => {
            io.observe(slider);
        });
    })
});

document.addEventListener('DOMContentLoaded', function() {
    function initSlider(slider) {
        if (slider.swiperInst) return;

        const nextButton = slider.querySelector('[data-slider-next]');
        const prevButton = slider.querySelector('[data-slider-prev]');
        const scrollSlider = slider.querySelector('.swiper');
        if (!scrollSlider) return;

        slider.swiperInst = new Swiper(scrollSlider, {
            direction: 'horizontal',
            slidesPerView: 2,
            spaceBetween: 16,
            speed: 400,
            breakpoints: {
                480: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 24
                },
                1024: {
                    slidesPerView: 5
                }
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        });
    }

    const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initSlider(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null,
        rootMargin: '0px 0px 100px 0px',
        threshold: 0.1
    });

    document.querySelectorAll('[data-featured-carousel]').forEach(slider => {
        io.observe(slider);
    });

    document.addEventListener('recommendations:loaded', function(e) {
        e.detail.section.querySelectorAll('[data-featured-carousel]').forEach(slider => {
            io.observe(slider);
        });
    })
});

document.addEventListener('DOMContentLoaded', function() {
    function initSlider(slider) {
        if (slider.swiperInst) return;

        const nextButton = slider.querySelector('[data-slider-next]');
        const prevButton = slider.querySelector('[data-slider-prev]');
        const scrollSlider = slider.querySelector('.swiper');
        if (!scrollSlider) return;

        slider.swiperInst = new Swiper(scrollSlider, {
            direction: 'horizontal',
            slidesPerView: 2,
            spaceBetween: 16,
            speed: 400,
            breakpoints: {
                480: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 24
                },
                1024: {
                    slidesPerView: 4
                }
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        });
    }

    const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initSlider(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null,
        rootMargin: '0px 0px 200px 0px',
        threshold: 0
    });

    document.querySelectorAll('[data-luxory-carousel]').forEach(slider => {
        io.observe(slider);
    });

    document.addEventListener('recommendations:loaded', function(e) {
        e.detail.section.querySelectorAll('[data-luxory-carousel]').forEach(slider => {
            io.observe(slider);
        });
    })
});

// Fix StoreAvailabilityDrawer stacking context
document.addEventListener('click', function(e) {
  if (!e.target.closest('.js-drawer-open-availability')) return;
  
  // Wait for drawer to open and be in DOM
  var attempts = 0;
  var interval = setInterval(function() {
    attempts++;
    var storeDrawer = document.getElementById('StoreAvailabilityDrawer');
    var cartDrawer = document.getElementById('CartDrawer');
    
    if (storeDrawer && cartDrawer) {
      clearInterval(interval);
      // Move next to cart drawer so stacking context matches
      cartDrawer.parentElement.appendChild(storeDrawer);
      // Fix position below sticky header
      var h = document.querySelector('.cm-sticky-header').offsetHeight;
      storeDrawer.style.setProperty('top', h + 'px', 'important');
      storeDrawer.style.setProperty('height', 'calc(100vh - ' + h + 'px)', 'important');
    }
    
    if (attempts > 20) clearInterval(interval); // give up after 2s
  }, 100);
});